import { createFileRoute } from '@tanstack/react-router'

import { RedeemEntryPoint } from '@/features/redeem/redeem.lazy'
import { useQuery } from '@tanstack/react-query'
import { getSelfExclusionPlayerOptions } from '@/apis/pam-rsg-api'
import { CircleLoadingAnimation } from '@vgw/multibrand-fe-circle-loading-animation'
import { SelfExclusionHeader } from '@/features/account-locked/self-exclusion-header'
import { AccountLockedLinks } from '@/features/account-locked/account-locked-links'

export const Route = createFileRoute('/_app/account-locked/self-exclusion')({
  component: RouteComponent,
})

function RouteComponent() {
  const { isPending, data } = useQuery({
    ...getSelfExclusionPlayerOptions(),
    // if no self exclusion would be 404, we don't want to retry it
    retry: false,
  })

  if (isPending) {
    return <CircleLoadingAnimation className="mx-auto" />
  }

  return (
    <>
      {data ? (
        <SelfExclusionHeader
          validTo={data.validTo}
          isIndefinite={data.type === 'INDEFINITE'}
        />
      ) : null}

      <AccountLockedLinks redemption accountVerification accessControls />
      <RedeemEntryPoint />
    </>
  )
}
